<template>
  <div class="p-page-wrapper">
    <template v-if="!currentProjectId">
      <v-row>
        <v-col>
          <p-no-data
            :text="$t('noProjects')"
            :hide-btn="true"
            img="document.png"
            class="p-no-data-mt"
          ></p-no-data>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <p-routed-tabs
        :tabs="accessibleTabs"
        class="pt-1"
      ></p-routed-tabs>
      <router-view/>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import PRoutedTabs from '@/components/PRoutedTabs'
import PNoData from '@/components/PNoData'

import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PRoutedTabs,
    PNoData
  },


  mixins: [
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      tabs: [
        { title: this.$t('documents.tabs.documents'), route: 'documentDocument' },
        { title: this.$t('documents.tabs.notes'), route: 'documentNotes' },
        { title: this.$t('documents.tabs.contracts'), route: 'documentContract' },
        { title: this.$t('documents.tabs.schedules'), route: 'documentSchedule' }
      ]
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId']),
    ...mapState('pageSettings', ['pageTitle', 'pageLoading'])
  },


  methods: {
    ...mapActions('contact', ['loadShortContacts']),
    ...mapActions('member', ['loadMembersByProject'])
  },


  async created () {
    this.setPageTitle(this.$t('nav.documents'))
    if (!this.currentProjectId) return false
    try {
      await this.loadShortContacts()
      await this.loadMembersByProject(this.currentProjectId)
      this.redirectToChildRouteWithAccess()
    } catch (error) {
      this.$log.error(error)
    }
  }
}
</script>
